<template>
  <div 
    class="product-page"
  >
    <div 
      v-if="product && selectedVariant" 
      class="pb-64 md:pb-80"
      :class="{
        'mb-48 !pb-56': model.layout && model.backgroundColorHexcode
      }"
      :style="{
        backgroundColor: model.layout === 'FullColorLayout' ? model.backgroundColorHexcode : '',
        color: model.layout && model.layout !== 'Default' ? model.textColor : ''
      }"  
    >
      <div
        :style="{
          backgroundColor: model.layout === 'BackgroundColorLayout' ? model.backgroundColorHexcode : '',
        }"
      >
        <div
          class="layout-container"
        >
          <div class="mx-auto md:w-full md:pb-32">
            <div
              class="pt-16 pb-12 underline text-xs sm:text-sm leading-sm cursor-pointer hover:no-underline h-[52px]"
              @click="navBack"
            >
              <div class="mr-8 inline-block align-middle">
                <ArrowLongLeftIcon
                  class="w-16 h-16"
                />
              </div>
              {{ sharedResources.navBack }}
            </div>
            <div class="single-product md:flex sm:mb-32">
              <div class="flex-shrink-0 md:pr-64 md:w-3/5">
                <ProductPageProductImages
                  class="mb-20 sm:mb-32"
                  :product="product"
                  :model-description="model.description"
                  :is-subscription="cartType === CartType.Subscription"
                  :flags-to-hide="flagsToHideOnSubscription"
                  :page="pageData"
                  :layout="model.layout"
                />
                <div
                  v-if="!isMobile && !isTablet && (!model.layout || model.layout === 'Deafult')"
                  class="hidden md:block"
                >
                  <ProductPageBreadcrumbs
                    :breadcrumbs="model.breadcrumbs"
                    :bg-color="model.backgroundColorHexcode"
                    :layout="model.layout"
                  />
                  <h2
                    class="text-xsmall-medium sm:text-small-medium mb-12 product-overview-title"
                  >
                    {{ product.name }} - {{ productResources.productData }} 
                  </h2>
                  <WysiwygWrapper
                    v-if="product.description"
                    :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                    :html="product.description"
                  />
                  <WysiwygWrapper
                    v-if="model.productDescription"
                    :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                    :html="model.productDescription"
                  />
                  <ProductPageFlavorInfo
                    v-if="showQuickInfoOnProductPage && product.flavorProfile && product.flavorProfile.length > 0 && !hideProductFlavorInfo"
                    :product="product"
                  />
                  <ProductPageAccordion
                    v-if="pageData.facts"
                    :product="product"
                    :facts="pageData.facts"
                  />
                </div>
              </div>
              <div
                class="sm:w-full pb-24 border-b border-grey400 mb-24 sm:mb-0 md:border-0 md:pb-0 -mx-24 px-24 sm:px-0 sm:mx-0"
                :class="{
                  'bg-white !p-24 rounded-md shadow-md !m-0': model.layout == 'BackgroundColorLayout',
                  '!border-0': model.layout == 'FullColorLayout',
                }"
              >
                <h1 class="mb-16 sm:mb-24">{{ product.name }}</h1>
                <div
                  v-if="!inStock(selectedVariant.inStock) && useRunnerStockStatus && selectedVariant.nextDeliveryDate && product.status !== 'Hidden'"
                  class="flex items-center p-12 px-16 sm:py-16 sm:px-20 bg-orange rounded-md mb-16"
                >
                  <TruckIcon class="h-16 w-16 sm:h-20 sm:w-20 mr-8 text-xs-medium" />
                  <div class="mt-4 flex text-xsmall-medium sm:text-small-medium">
                    {{ productResources.isSent }} {{ getLocaleDate(selectedVariant.nextDeliveryDate, { month: 'long', day: 'numeric', year: 'numeric' }) }}
                  </div>
                </div>
                <div v-if="product.status === 'Hidden'" class="text-small-medium mb-12">
                  <div class="bg-error h-8 w-8 rounded-full inline-block mr-8" /> {{ productResources.productExpired }}
                </div>
                <div v-else-if="allVariantsOutOfStock && !useRunnerStockStatus" class="text-small-medium mb-12">
                  <div class="bg-error h-8 w-8 rounded-full inline-block mr-8" /> {{ productResources.temporaryOutOfStock }}
                </div>
                <div
                  v-if="!isLoggedIn && onlyAvailableInStore"
                  class="rounded-md p-12 relative text-xsmall sm:text-xsmall-regular bg-grey200"
                >
                  <div class="mb-12 flex">
                    <img
                      :src="`/heroicons/outline/information-circle.svg`"
                      class="w-20 h-20 mr-8 flex-shrink-0"
                      :alt="'information-circle'"
                      height="20"
                      width="20"
                    >
                    <div>{{ productResources.createAccountToCollectInStore }}</div>
                  </div>
                  <button
                    class="btn btn--secondary w-full"
                    @click="onShowLogin"
                  >
                    {{ checkoutResources.login }}
                  </button>
                </div>
                <ProductInfo
                  v-if="showQuickInfoOnProductPage"
                  :product="product"
                  class="mb-32"
                />
                <div
                  v-if="
                    variants && variants.length > 1 &&
                      product.subscribableVariants.length > 0 &&
                      product.status !== 'Hidden' && !product.isExpiring
                  "
                >
                  <label class="text-xs sm:text-sm text-small-medium mb-8 block sm:mb-12">
                    {{ productResources.buyOnceOrSubscribe }}
                  </label>
                  <div
                    class="flex mb-24"
                  >
                    <div
                      class="tabs text-xsmall-medium sm:text-small-medium mr-6 cursor-pointer select-none rounded-md border border-grey400 flex justify-center items-center w-full h-40 animate-all hover:border-grey600 sm:h-48"
                      :class="{
                        'shadow-border-black !border-black':
                          cartType === CartType.Standard,
                      }"
                      @click="setCartType(CartType.Standard)"
                    >
                      {{ productResources.buyOnce }}
                    </div>
                    <div
                      class="tabs text-xsmall-medium sm:text-small-medium ml-6 cursor-pointer select-none rounded-md border border-grey400 flex justify-center items-center w-full h-40 animate-all hover:border-grey600 sm:h-48"
                      :class="{
                        'shadow-border-black !border-black':
                          cartType === CartType.Subscription,
                      }"
                      @click="setCartType(CartType.Subscription)"
                    >
                      {{ productResources.subscribe }}
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="
                    product.status !== 'Hidden' &&
                      product.status !== 'Expiring' &&
                      product.variants[0].price.value &&
                      !allVariantsOutOfStock &&
                      !product.isExpiring &&
                      product.subscribableVariants.length > 0 ||
                      product.variants.length <= 1
                  "
                  class="text-small-regular sm:text-heading"
                >
                  {{ formatPrice(product.variants[0].price.value) }}
                </div>
                <label
                  v-if="product.productType === 'Standard' && variants && variants.length > 1 && product.status !== 'Hidden'"
                  class="text-xsmall-medium sm:text-small-medium mb-8 block sm:mb-12"
                >
                  {{ productResources.chooseSize }}
                </label>
                <div v-if="product.productType === 'Bundle' && product.status !== 'Hidden'" class="flex mt-12">
                  <GenericSelector
                    class="quantity-selector h-40 sm:h-48 mr-12 flex-shrink-0"
                    :default-option="selectedQuantity"
                    :small-select="false"
                    :quantity-select="true"
                    :items="quantityOptions"
                    :placeholder="'1'"
                    @change="updateQuantity"
                  />
                  <div
                    class="relative overflow-hidden w-full h-40 flex rounded-md mb-8 animate-all sm:h-48 shadow-border-black"
                  >
                    <label
                      class="base-text block w-full px-12 sm:px-16 cursor-pointer"
                    >
                      <div
                        v-if="variants && variants.length"
                        class="relative pl-24 sm:pl-28 flex justify-between items-center h-full text-xsmall-medium sm:text-small-medium"
                      >
                        <div class="mt-2 sm:mt-px">
                          <input
                            v-if="variants[0].partNo"
                            :id="variants[0].partNo"
                            class="variant-input flex items-center justify-center appearance-none w-16 h-16 border border-grey600 absolute left-0 rounded top-1/2 transform -translate-y-1/2"
                            :checked="true"
                            type="radio"
                            :value="variants[0].partNo"
                            required
                          >
                          {{ productResources.mixPackage }}
                          <span v-if="variants[0].price.valuePerCan" class="font-normal ml-6 lowercase">
                            ({{ formatPrice(variants[0].price.valuePerCan) }} /{{ productResources.can }})
                          </span>
                        </div>
                        <div v-if="variants[0].price.value" class="mt-2 sm:mt-px">
                          {{ formatPrice(variants[0].price.value) }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div v-else-if="variants && variants.length > 1">
                  <div
                    v-for="variant in variants"
                    :key="variant.partNo"
                    class="relative overflow-hidden w-full h-40 flex rounded-md mb-8 animate-all sm:h-48"
                    :class="{
                      '!border-black shadow-border-black': selectedVariant.partNo === variant.partNo && (inStock(variant) || useRunnerStockStatus) && product.status !== 'Hidden',
                      'border border-grey400 hover:border-grey800': (inStock(variant) || useRunnerStockStatus) && product.status !== 'Hidden',
                      'pointer-events-none': product.status === 'Hidden'
                    }"
                  >
                    <div
                      v-if="!inStock(variant) && !useRunnerStockStatus || product.status === 'Hidden'"
                      class="w-full base-text block px-12 sm:px-16 pointer-events-none bg-grey200"
                    >
                      <div class="relative pl-24 sm:pl-28 flex justify-between items-center h-full text-xsmall-medium sm:text-small-medium pointer-events-none text-grey600">
                        <div class="mt-2 sm:mt-px">
                          <input
                            v-if="variant.partNo"
                            :id="variant.partNo"
                            class="variant-input flex items-center justify-center appearance-none w-16 h-16 border absolute left-0 rounded top-1/2 transform -translate-y-1/2 border-grey400"
                            type="radio"
                            :value="variant.partNo"
                          >
                          <span v-if="variant.packageSize === 1" class="line-through">
                            {{ productResources.can }}
                          </span>
                          <div v-else>
                            <span class="line-through">{{ variant.packageSize }}-pack</span>
                            <div
                              v-if="product.status !== 'Hidden' && variant.price.valuePerCan"
                              class="font-normal ml-6 inline"
                            >
                              ({{ formatPrice(variant.price.valuePerCan) }} /<span class="lowercase">{{ productResources.can }}</span>)
                            </div>
                          </div>
                        </div>
                        <div v-if="product.status !== 'Hidden' && variant.price.value" class="text-black mt-2 sm:mt-px">
                          {{ formatPrice(variant.price.value) }}
                        </div>
                      </div>
                    </div>
                    <label
                      v-else
                      class="base-text block w-full px-12 sm:px-16 cursor-pointer"
                      :for="variant.partNo"
                    >
                      <div class="relative pl-24 sm:pl-28 flex justify-between items-center h-full text-xsmall-medium sm:text-small-medium">
                        <div class="mt-2 sm:mt-px">
                          <input
                            v-if="variant.partNo"
                            :id="variant.partNo"
                            class="variant-input flex items-center justify-center appearance-none w-16 h-16 border border-grey600 absolute left-0 rounded top-1/2 transform -translate-y-1/2"
                            :checked="selectedVariant.partNo === variant.partNo"
                            type="radio"
                            :value="variant.partNo"
                            required
                            @change="selectVariant(variant.partNo ? variant : selectedVariant)"
                          >
                          <span v-if="variant.packageSize === 1">
                            {{ productResources.can }}
                          </span>
                          <div v-else>
                            {{ variant.packageSize }}-pack
                            <span v-if="variant.price.valuePerCan" class="font-normal ml-6 lowercase">
                              ({{ formatPrice(variant.price.valuePerCan) }} /{{ productResources.can }})
                            </span>
                          </div>
                        </div>
                        <div v-if="variant.price.value" class="mt-2 sm:mt-px">
                          {{ formatPrice(variant.price.value) }}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
                <div v-if="allVariantsOutOfStock && !useRunnerStockStatus && product.status !== 'Hidden'">
                  <AllVariantsOutOfStock
                    :part-no="product.partNo"
                    :is-added-to-favourites="isAddedToFavourites(product.partNo)"
                    @add-to-favourites="toggleFavourites"
                  />
                </div>
                <div v-else-if="product.status !== 'Hidden'">
                  <div
                    v-if="cartType === CartType.Subscription"
                    class="mt-24"
                  >
                    <div class="text-xsmall-medium sm:text-small-medium mb-4">
                      {{ checkoutResources.whichOrderInterval }}
                    </div>
                    <div class="text-xsmall sm:text-small-regular mb-16">
                      {{ checkoutResources.whichOrderIntervalDescription }}
                    </div>
                    <GenericSelector
                      :default-option="selectedInterval"
                      :items="intervalOptions"
                      :upwards-select="false"
                      :xlarge-select="true"
                      @change="updateInterval"
                    />
                  </div>
                  <div
                    v-if="!stableLoginStatus && isExclusiveProduct"
                    class="relative h-auto min-h-96"
                  >
                    <img
                      :src="'/lottie-animations/spinner-svg.svg?url'"
                      :height="20"
                      :width="20"
                      class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                    >
                  </div>
                  <div
                    v-else-if="stableLoginStatus && isExclusiveProduct && !isLoggedIn"
                    class="py-24 px-16 md:py-32 sm:px-24 bg-orange rounded mt-24 sm:mt-32"
                  >
                    <div class="mb-12 flex items-center">
                      <img
                        :src="'/heroicons/outline/star.svg'"
                        alt="stjärna"
                        class="mr-8 mb-6 hidden md:block"
                        height="24"
                        width="24"
                      >
                      <h2>Medlemsexklusiv produkt</h2>
                    </div>
                    <div class="text-xsmall md:text-small-regular mb-16 sm:mb-24">
                      {{ productResources.exklusiveProductLoginInfo }}
                    </div>
                    <div class="md:grid md:grid-cols-2 md:space-x-12">
                      <button
                        class="btn btn--primary w-full mb-12 md:mb-0"
                        @click="onShowLogin"
                      >
                        {{ productResources.loginAction }}
                      </button>
                      <button
                        class="btn btn--secondary w-full"
                        @click="onShowSignup"
                      >
                        {{ productResources.signupAction }}
                      </button>
                    </div>
                  </div>
                  <div v-else-if="stableLoginStatus" class="flex flex-wrap mt-12">
                    <GenericSelector
                      v-if="product.productType !== 'Bundle' && variants && variants.length < 2"
                      class="quantity-selector quantity-selector--light h-40 sm:h-48 mr-12 flex-shrink-0"
                      :default-option="selectedQuantity"
                      :small-select="false"
                      :quantity-select="true"
                      :items="quantityOptions"
                      :placeholder="'1'"
                      @change="updateQuantity"
                    />
                    <AnimatedBuyButton
                      class="btn btn--primary flex-1 h-40 md:h-48"
                      :button-text="productResources.addToBasket"
                      :product="product"
                      :selected-variant="selectedVariant"
                      :cart-type="cartType"
                      :selected-quantity="selectedQuantity.value"
                    />
                    <button
                      :title="productResources.addToFavourites"
                      class="btn btn--secondary ml-16 px-12 w-40 h-40 md:h-48 md:w-48"
                      @click="toggleFavourites(product.partNo)"
                    >
                      <BookmarkIcon class="w-20 h-20 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                      <client-only>
                        <transition name="fade" mode="out-in">
                          <BookmarkIconSolid v-if="isAddedToFavourites(product.partNo)" class="w-20 h-20 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
                        </transition>
                      </client-only>
                    </button>
                  </div>
                </div>
                <RelatedProducts
                  v-if="(product.productType === 'Bundle' || (isMobile || isTablet)) && pageData.relatedProducts && pageData.relatedProducts.length"
                  class="mt-24"
                  :is-bundle-product="product.productType === 'Bundle'"
                  :product="product"
                  :page="pageData"
                />
                <!-- Product description if full color background-->
                <div v-if="model.layout === 'FullColorLayout'" class="mt-24">
                  <div v-if="!isMobile && !isTablet" class="hidden md:block">
                    <h2
                      class="text-xsmall-medium sm:text-small-medium mb-12 product-overview-title"
                    >
                      {{ product.name }} - {{ productResources.productData }} 
                    </h2>
                    <WysiwygWrapper
                      v-if="product.description"
                      :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                      :html="product.description"
                    />
                    <WysiwygWrapper
                      v-if="model.productDescription"
                      :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                      :html="model.productDescription"
                    />
                    <ProductPageFlavorInfo
                      v-if="showQuickInfoOnProductPage && product.flavorProfile && product.flavorProfile.length > 0 && !hideProductFlavorInfo"
                      :product="product"
                    />
                    <ProductPageAccordion
                      v-if="pageData.facts"
                      :product="product"
                      :facts="pageData.facts"
                      :dark-theme="true"
                    />
                  </div>
                </div>
                <ProductStockStatus
                  v-if="productAvailability && !product.isRunner && product.status !== 'Hidden' && cartType != CartType.Subscription && productSettings.enableStoreInventory"
                  class="mt-24"
                  :product-availability="productAvailability"
                  :selected-variant-id="selectedVariant.id"
                  :product-part-no="product.partNo"
                  :is-added-to-favourites="isAddedToFavourites(product.partNo)"
                  @add-to-favourites="toggleFavourites"
                />
                <ProductPageUsps v-if="product.status !== 'Hidden'" class="mt-16" />
                <button
                  v-if="product.status === 'Hidden'"
                  class="btn btn--primary w-full h-40 md:h-48"
                  @click="scrollToRelated('relatedProducts')"
                >
                  {{ productResources.seeRelatedProducts }}
                </button>
              </div>
            </div>
            <div
              v-if="isMobile || isTablet"
              class="block md:hidden"
              :class="{
                'bg-white -mx-24 pt-24 px-24 mt-32 md:mx-0 md:p-0': model.layout === 'BackgroundColorLayout'
              }"
            >
              <ProductPageBreadcrumbs
                :breadcrumbs="model.breadcrumbs"
                :bg-color="model.backgroundColorHexcode"
                :layout="model.layout"
              />
              <h2
                class="text-xsmall-medium sm:text-small-medium mb-12 product-overview-title"
              >
                {{ product.name }} - {{ productResources.productData }} 
              </h2>

              <WysiwygWrapper
                v-if="product.description"
                :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                :html="product.description"
              />
              <WysiwygWrapper
                v-if="model.productDescription"
                :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
                :html="model.productDescription"
              />
              <ProductPageFlavorInfo
                v-if="showQuickInfoOnProductPage && product.flavorProfile && product.flavorProfile.length > 0 && !hideProductFlavorInfo"
                :product="product"
              />
              <ProductPageAccordion
                v-if="pageData.facts"
                :product="product"
                :facts="pageData.facts"
                :dark-theme="model.layout && model.layout === 'FullColorLayout' || false"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Product description if background color -->
      <div v-if="model.layout === 'BackgroundColorLayout' && !isMobile && !isTablet" class="layout-container pt-32 hidden md:block">
        <div class="mx-auto flex-shrink-0 md:mx-0 md:pr-64 md:w-3/5">
          <div>
            <ProductPageBreadcrumbs
              :breadcrumbs="model.breadcrumbs"
              :bg-color="model.backgroundColorHexcode"
              :layout="model.layout"
            />
            <h2
              class="text-xsmall-medium sm:text-small-medium mb-12 product-overview-title"
            >
              {{ product.name }} - {{ productResources.productData }} 
            </h2>
            <WysiwygWrapper
              v-if="product.description"
              :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
              :html="product.description"
            />
            <WysiwygWrapper
              v-if="model.productDescription"
              :style-config="{ 'wysiwyg wysiwyg--sm-text mb-24': true }"
              :html="model.productDescription"
            />
            <ProductPageFlavorInfo
              v-if="showQuickInfoOnProductPage && product.flavorProfile && product.flavorProfile.length > 0 && !hideProductFlavorInfo"
              :product="product"
            />
            <ProductPageAccordion
              v-if="pageData.facts"
              :product="product"
              :facts="pageData.facts"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showHealthWarning" class="layout-container mb-48 md:mb-64">
      <div
        class="products-page-health-warning px-8 py-12 sm:py-16 sm:px-16 text-center rounded-md flex justify-center items-center border-black border-2"
        v-html="healthWarning"
      />
    </div>
    <div class="relative">
      <div id="relatedProducts" class="absolute top-0 transform -translate-y-[50px]" />
      <SimilarProducts
        :products="relatedProducts"
      />
    </div>
    <div class="relative">
      <div
        v-if="!relatedProducts || !relatedProducts.length"
        id="relatedProducts"
        ref="related"
        class="absolute top-0 transform -translate-y-[50px]"
      />
      <SameBrandProducts
        :brand-name="product.brand.name"
        :brand-url="model.brandUrl"
        :products="model.pageData.sameBrandProducts"
      />
    </div>
    <EpiserverContentArea
      v-if="model.additionalContent"
      v-epi-edit="'AdditionalContent'"
      :model="model.additionalContent"
      class="pb-24 sm:pb-32 overflow-x-hidden"
    />
  </div>
</template>

<script setup lang="ts">
import type { ProductPage } from '~/content-types';
import { CartType, type IVariant, SubscriptionInterval, type IProductPageData, type IParametric, type IFlag, type ITag } from '~/api-types';
import { computed, type Ref, ref, onMounted } from 'vue';
import ArrowLongLeftIcon from '@heroicons/vue/24/outline/esm/ArrowLongLeftIcon';
import BookmarkIcon from '@heroicons/vue/24/outline/esm/BookmarkIcon';
import BookmarkIconSolid from '@heroicons/vue/24/solid/esm/BookmarkIcon';
import { useGlobalContentStore } from '~/store/globalContent';
import ProductPageAccordion from '~/components/product-page/ProductPageAccordion.vue';
import AllVariantsOutOfStock from '~/components/product-page/AllVariantsOutOfStock.vue';
import ProductPageUsps from '~/components/product-page/ProductPageUsps.vue';
import ProductPageBreadcrumbs from '~/components/product-page/ProductPageBreadcrumbs.vue';
import ProductPageProductImages from '~/components/product-page/ProductPageProductImages.vue';
import SimilarProducts from '~/components/product-page/SimilarProducts.vue';
import SameBrandProducts from '~/components/product-page/SameBrandProducts.vue';
import ProductInfo from '~/components/product-page/ProductInfo.vue';
import ProductStockStatus from '~/components/product-page/ProductStockStatus.vue';
import ProductPageFlavorInfo from '~/components/product-page/ProductPageFlavorInfo.vue';
import RelatedProducts from '~/components/product-page/RelatedProducts.vue';
import AnimatedBuyButton from '~/components/form-elements/AnimatedBuyButton.vue';
import { useFavouritesStore } from '~/store/favourites';
import GenericSelector from '~/components/form-elements/GenericSelector.vue';
import useLocalDate from '~/composables/useLocalDate';
import TruckIcon from '@heroicons/vue/24/outline/esm/TruckIcon';
import { useVoyadoStore } from '~/store/voyado';
import { useUiStore } from '~/store/ui';
import useFormatPrice from '~/composables/useFormatPrice';
import { useCartStore } from '~/store/cart';
import { storeToRefs } from 'pinia';

const uiStore = useUiStore();
const { isMobile, isTablet } = storeToRefs(uiStore);
const { apiGet } = useApiFetch();
const { formatPrice } = useFormatPrice();
const sharedResources = useGlobalContentStore().sharedResources;
const productResources = useGlobalContentStore().productResources;
const globalContentStore = useGlobalContentStore();
const marketSettings = useGlobalContentStore().marketSettings;
const checkoutSettings = useGlobalContentStore().checkoutSettings;
const productSettings = useGlobalContentStore().productSettings;
const marketUrl = globalContentStore.marketSettings.url;
const router = useRouter();
const route = useRoute();
const favouritesStore = useFavouritesStore();
const favouritesArray: Ref<string[]> = ref([]);
const showHealthWarning : Ref<boolean> = ref(false);
const nicotinePouchesCategoryCode = 'M-M1000716545';
const { getLocaleDate } = useLocalDate();
const voyadoStore = useVoyadoStore();
const preselectSubscription = ref(route.query.cartType);
const cartResources = ref(globalContentStore.cartResources);
const checkoutResources = ref(globalContentStore.checkoutResources);
const cartStore = useCartStore();
const flagsToHideOnSubscription = productSettings.flagsToHideOnSubscription;
const showQuickInfoOnProductPage = productSettings.showQuickInfoOnProductPage;
const { isLoggedIn, hasLoadedCheckLoginStatus } = storeToRefs(uiStore);
const stableLoginStatus = ref(hasLoadedCheckLoginStatus.value);

const quantityOptions = ref([
  { name: '1', value: 1 },
  { name: '2', value: 2 },
  { name: '3', value: 3 },
  { name: '4', value: 4 },
  { name: '5', value: 5 },
  { name: '6', value: 6 },
  { name: '7', value: 7 },
  { name: '8', value: 8 },
  { name: '9', value: 9 },
  { name: '10', value: 10 },
]);

const product = ref();
const selectedVariant = ref();
const productAvailability = ref();

const intervalOptions = ref([
  { name: cartResources.value.subscriptionIntervalEveryWeek, value: SubscriptionInterval.EveryWeek },
  { name: cartResources.value.subscriptionIntervalEveryOtherWeek, value: SubscriptionInterval.EveryOtherWeek },
  { name: cartResources.value.subscriptionIntervalEveryThreeWeeks, value: SubscriptionInterval.EveryThreeWeeks },
  { name: cartResources.value.subscriptionIntervalEveryFourWeeks, value: SubscriptionInterval.EveryFourWeeks },
]);

const selectedInterval = ref(intervalOptions.value[0]);

favouritesArray.value = favouritesStore.favourites;

const props = defineProps<{
  model: ProductPage;
}>();

const pageData = props.model.pageData as IProductPageData;
product.value = pageData.product;

const healthWarning = computed(() => {
  return productSettings?.nicotinePouchesHealthWarning;
});

const hideProductFlavorInfo = computed(() => {
  let hasEmptyValue = false;
  product.value.flavorProfile.some((flavor: IParametric) => {
    if (!flavor.value) {
      hasEmptyValue = true;
    }
  });

  return hasEmptyValue;
});

const flags = computed<IFlag[] | null>(() => {
  return product.value?.flags
    .filter((item: IFlag) =>
      product.value?.tags.some((tag: ITag) => tag.urlSegment === item.urlSegment)
    )
    .sort((a, b) => (a.groupName === 'E-com Members Flags' ? -1 : b.groupName === 'E-com Members Flags' ? 1 : 0));
});

const isExclusiveProduct = computed(() => {
  return  flags.value?.some((flag: IFlag) => flag.groupName === 'E-com Members Flags') ?? false;
});

onMounted(async()=> {
  setTimeout(async() => {
    await fetchProductAvailability();
  }, 10);

  if (selectedVariant.value) {
    voyadoStore.sendProductView(product.value.category?.name, selectedVariant?.value.partNo);
  }

  nextTick(async() => {
    window.dataLayer?.push({
      event: 'productDetail',
      ecommerce: {
        currencyCode: marketSettings.currency.currencyCode,
        detail: {
          products: [
            {
              brand: product.value.brand?.name,
              category: product.value.category?.name,
              id: product.value.partNo,
              name: product.value.name,
              price: selectedVariant?.value?.price.value,
              variant: product.value.productType === 'Bundle' ?
                '5-pack' :
                selectedVariant?.value ? selectedVariant?.value.packageSize + '-pack' : '',
              quantity: 1,
            },
          ],
        },
      },
      personalized: uiStore.personalized,
    });
  });
});

const cartType = ref<CartType>(CartType.Standard);
if (preselectSubscription.value) {
  cartType.value = CartType.Subscription;
}
const setCartType = (value: CartType) => {
  cartType.value = value;
  preSelectVariant();
};

const inStock = (variant: IVariant) => {
  if (isLoggedIn.value) {
    return variant.availability?.online || variant.availability?.inStore;
  } else {
    return variant.availability?.online;
  }
};

const preSelectVariant = () => {
  const variants = cartType.value === CartType.Subscription ?
    product.value?.subscribableVariants :
    product.value?.variants;

  // Choose preselected variant if in stock, else choose first variant in stock
  let preferredVariant = variants.find(variant => variant.isPreferredVariant);
  if (preferredVariant && preferredVariant.inStock) {
    selectedVariant.value = preferredVariant;
  } else if (
    productSettings?.preSelectedProductVariantIndex &&
      variants[productSettings?.preSelectedProductVariantIndex] &&
      variants[productSettings?.preSelectedProductVariantIndex].inStock || useRunnerStockStatus.value
  ) {
    selectedVariant.value = variants[productSettings?.preSelectedProductVariantIndex];
  } else if (variants.find(variant => inStock(variant))) {
    selectedVariant.value = variants.find(variant => inStock(variant));
  } else {
    selectedVariant.value = variants[0];
  }
};

const useRunnerStockStatus = computed(() => {
  return product.value?.isRunner && !productSettings.disablePurchaseIfOutOfStock;
});

const relatedProducts = computed(() => {
  const relationTypes = ['UpSell', 'CrossSell', 'Accessory-2', 'Accessory-3'];
  return pageData.relatedProducts?.filter((relation) => relationTypes.includes(relation.type))
    .map((relation) => relation.product);
});

const updateInterval = (interval: { name: string; value: SubscriptionInterval }) => {
  selectedInterval.value = interval;
  cartStore.updateInterval(interval.value);
};

preSelectVariant();

if (healthWarning.value && product.value.categoryCode === nicotinePouchesCategoryCode) {
  showHealthWarning.value = true;
}

const selectVariant = (value: IVariant) => {
  selectedVariant.value = value;
};

const selectedQuantity = ref(quantityOptions.value[0]);

const updateQuantity = (quantity: { value: number, name: string }) => {
  selectedQuantity.value = quantity;
};

const variants = computed<IVariant[] | null>(()=> {
  if (cartType.value === CartType.Subscription) {
    return product.value?.subscribableVariants || [];
  } else {
    return product.value?.variants || [];
  }
});

const allVariantsOutOfStock = computed<boolean>(()=> {
  let hasVariantInStock = false;
  variants.value?.forEach((variant: IVariant) => {
    if (variant.availability.online) {
      hasVariantInStock = true;
    }

    if (variant.availability.inStore && !variant.availability.online && isLoggedIn.value) {
      hasVariantInStock = true;
    }

    if (variant.inStock && cartType.value === CartType.Subscription) {
      hasVariantInStock = true;
    }
  });
  return !hasVariantInStock;
});

const priceListId = computed(() => {
  const firstVariantWithPriceListId = product?.value?.variants?.find((variant: any) => {
    return variant?.price?.priceListId;
  });

  if (firstVariantWithPriceListId) {
    return firstVariantWithPriceListId.price.priceListId;
  }
  return '1';
});

const fetchProductAvailability = async() => {
  const query = `product/availability?PartNo=${product.value.partNo}&PricelistId=${priceListId.value}&countryCode=${marketSettings.countryCode}&language=${marketSettings.contentLanguage}`;
  productAvailability.value = await apiGet<string>(query);
};

const currentVariantStockStatus = computed(() => {
  const variant = productAvailability?.value?.find((variant: any) => {
    return variant.variantId === selectedVariant.value?.id;
  });
  return variant;
});

const onlyAvailableInStore = computed(() => {
  const inStockStore = currentVariantStockStatus.value?.stores.find((store: any) => {
    return store?.availability.inStock;
  });
  return checkoutSettings.enableClickAndCollect && inStockStore && !currentVariantStockStatus.value.online.inStock;
});

const navBack = (() => {
  router.go(-1);
  if ((window.history.length > 1 && 
      document.referrer.indexOf(window.location.host) !== -1) ||
      sessionStorage.getItem('has-history-on-page')) {
  } else {
    window.location.href = marketUrl;
  }
});

const isAddedToFavourites = ((partNo: string) => {
  return favouritesArray.value && favouritesArray.value.includes(partNo);
});

const onShowLogin = () => {
  uiStore.setLoginType('login');
  uiStore.setShowLogin(true);
  uiStore.setPreventLoginNavigate(true);
};

const onShowSignup = () => {
  uiStore.setLoginType('signup');
  uiStore.setShowLogin(true);
  uiStore.setPreventLoginNavigate(true);
};

const addToFavourites = (async(partNo: string) => {
  if (uiStore.isIdentifiedContact) {
    favouritesArray.value.push(partNo);
    await favouritesStore.addToFavourites(partNo);

    window.dataLayer?.push({
      'event': 'addToFavList',
      'favProductName': product.value.name,
    });
  } else {
    onShowLogin();
  }
});

const removeFromFavourites = (async(partNo: string) => {
  const index = favouritesArray.value.indexOf(partNo);
  if (index !== -1) {
    favouritesArray.value.splice(index, 1);
  }
  await favouritesStore.removeFromFavourites(partNo);
});

const toggleFavourites = (async(partNo: string) => {
  if (favouritesArray.value.includes(partNo)) {
    removeFromFavourites(partNo);
  } else {
    addToFavourites(partNo);
  }
});

const scrollToRelated = (id: string) => {
  const element = document.getElementById(id);
  if (element) {
    const offset = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: offset - 50,
      left: 0,
      behavior: 'smooth',
    });
  }
};

// Watch for changes and add a slight delay to prevent flickering
watch(hasLoadedCheckLoginStatus, (newValue) => {
  if (newValue) {
    stableLoginStatus.value = true;
  } else {
    setTimeout(() => {
      stableLoginStatus.value = hasLoadedCheckLoginStatus.value;
    }, 300); // Adjust delay as needed
  }
});

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.value?.name,
  image: product.value?.imageUrl,
  description: product.value?.description,
  url : product.value?.url,
  sku : product.value?.id,
  mpn: selectedVariant.value?.partNo,
  brand: {
    '@type': 'Thing',
    name: product.value?.brand ? product.value?.brand[0]?.name : '',
  },
  'offers': {
    '@type' : 'Offer',
    price : selectedVariant.value?.price?.value,
    priceCurrency : selectedVariant.value?.price?.currencyCode,
    availability: selectedVariant.value?.inStock ? 'InStock' : 'OutOfStock',
  },
};

useHead({
  link: [
    {
      rel: 'canonical',
      href: product.value.url.toLowerCase(),
    },
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonLd),
    },
  ],
});

</script>

<style lang="postcss">
.product-overview-title {
  font-family: DIN Pro, sans-serif;
}
.quantity-selector {
  .custom-select {
    @apply h-40 sm:h-48 shadow-border-black w-56;
    .selected {
      @apply pl-16;
    }
  }
  &--light {
    .custom-select {
      @apply border-grey400 shadow-none;
    }
  }
}

.variant {
  &.checkbox-checked {
    label {
      @apply text-grey600;
    }

    .checkbox-container input:checked ~ .checkmark {
      @apply border-grey600 bg-grey600;
    }
  }
}

input[type='radio'] {
  &:checked {
    @apply bg-black border-black;
  }
}

input[type='checkbox'] {
  &:checked::before {
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    content: '';
  }
}

input[type='radio'] {
  @apply rounded-full;
  &:checked::before {
    @apply bg-white h-6 w-6 rounded-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2;

    content: '';
  }
}

.products-page-health-warning {
  *,
  p {
    @apply !font-arial font-bold text-base leading-xs tracking-[-0.4px] md:leading-[32px] md:font-bold md:text-xl md:tracking-xs;
  }
}

.loader {
  border-top-color: #fff;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}
@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
